/* Built In Imports */
import React from 'react';
/* External Imports */
import {
  Box,
  Center,
  CloseButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import MediaEmbed from '@components/Embeds/MediaEmbed';
import { IoPlaySharp } from 'react-icons/io5';
/* Internal Imports */
/* Components */
/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
// import LazyLoadImageComponent from '@moms/Ui/LazyLoadImageComponent';
const MiraclePopup = ({ media, ...props }) => {
  // console.log(media, 'media');
  const PlayButton = () => {
    return (
      <Center
        width={90}
        h={90}
        _hover={{ bg: '#DBDBDB' }}
        bg="#FDFDFD"
        color="#EC1B2E"
        rounded="full"
        fontSize="50px"
      >
        <IoPlaySharp style={{ marginRight: '-5px' }} />
      </Center>
    );
  };
  //   const [isHovered, setIsHovered] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  //   useEffect(() => {
  //     if (!isOpen) {
  //       setIsHovered(false);
  //     }
  //   }, [isOpen]);
  return (
    <Box
      pos="relative"
      //   display={{ base: 'block', md: 'none' }}
      //   onClick={() => setIsHovered(true)}
      //   onMouseEnter={() => setIsHovered(true)}
      //   onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <Center onClick={onOpen}>
        <PlayButton />
      </Center>
      {/* <Button onClick={onOpen}>Open Modal</Button> */}

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        size="full"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody
            alignItems="center"
            justifyContent="center"
            display="flex"
            w="100%"
            height="100%"
          >
            <Box w="100%" height="100%">
              <Center
                width="80vw"
                height="80vh"
                pos="relative"
                bg="#010102"
                border=".5rem solid #fff"
                mx="auto"
                my="auto"
              >
                <CloseButton
                  onClick={onClose}
                  top="-1rem"
                  pos="absolute"
                  right="-1rem"
                  bg="#fff"
                  padding=".5rem"
                  fontSize="1rem"
                  width="auto"
                  height="auto"
                  rounded="full"
                  boxShadow="0px 8px 8px 0px rgba(0, 0, 0, 0.16)"
                />
                <MediaEmbed sectionContent={media} />
              </Center>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
export default MiraclePopup;
